<template>
	<div class="checkbox">
		<input type="checkbox" :id="id" :checked="checked"
			   v-on:change="onChange" :data-param="param"/>
		<label :for="id" class="switcher"></label>
		<label :for="id">{{label}}</label>
	</div>
</template>

<script>
	export default {
		name: "Checkbox",

		props: {
			id: String,
			label: String,
			checked: Boolean,
			param: String
		},

		methods: {
			onChange(e){
				this.$emit("change", e.target.checked, e.target.dataset["param"], e);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../assets/scss/_variables.scss";

	.checkbox {
		margin: 0 0 18px;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 3px 0 0;

		input[type="checkbox"] {
			opacity: 0;
			visibility: hidden;
			position: absolute;

			&:checked {
				+ .switcher {
					background: $azure;

					&:before {
						left: 13px;
					}
				}
			}
		}

		.switcher {
			width: 28px;
			height: 10px;
			background: $bali;
			position: relative;
			border-radius: 10px;
			margin: 0 12px 0 0;
			transition: all 0.4s ease;

			&:before {
				position: absolute;
				left: 0;
				top: 50%;
				box-shadow: 0 3px 6px rgba(49, 57, 69, 0.5);
				border: 1px solid $bali;
				width: 16px;
				height: 16px;
				transform: translate(0, -50%);
				content: '';
				background: $white;
				border-radius: 100%;
				transition: all 0.4s ease;
			}
		}
	}

</style>
